import { jsx as _jsx } from "react/jsx-runtime";
import { Toast } from "./Toast";
import styles from "./ToastContainer.module.css";
export const ToastContainer = ({ toasts, onRemove }) => {
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: styles.container, "aria-live": "polite", "aria-label": "Notifications", children: toasts.map((toast) => (_jsx(Toast, { toast: toast, onClose: onRemove }, toast.id))) }));
};
